import API from 'services/api';

export const notificationMarkAsRead = ({ payload }: { payload: string[] }) =>
  API.post('/api/notifications/markAsRead', payload);
